const MS_PER_DAY = 24 * 60 * 60 * 1000;

const parseDateOnly = (value) => {
  if (!value) return null;
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const calculateAgeYears = (dateOfBirth, today = new Date()) => {
  const birthDate = parseDateOnly(dateOfBirth);
  if (!birthDate) return null;

  let years = today.getFullYear() - birthDate.getFullYear();
  const birthdayThisYear = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
  if (today < birthdayThisYear) {
    years -= 1;
  }

  return years < 0 ? null : years;
};

export const calculateAgeDays = (dateOfBirth, today = new Date()) => {
  const birthDate = parseDateOnly(dateOfBirth);
  if (!birthDate) return null;
  const diff = Math.floor((today.setHours(0, 0, 0, 0) - birthDate.getTime()) / MS_PER_DAY);
  return diff < 0 ? null : diff;
};

export const deriveAgeGroupFromDateOfBirth = (dateOfBirth, today = new Date()) => {
  const ageYears = calculateAgeYears(dateOfBirth, today);
  const ageDays = calculateAgeDays(dateOfBirth, new Date(today));
  if (ageYears == null || ageDays == null) return "";

  if (ageDays < 365) return "infant";
  if (ageYears <= 2) return "toddler";
  if (ageYears <= 12) return "child";
  if (ageYears <= 17) return "teen";
  if (ageYears >= 65) return "older_adult";
  return "adult";
};

export const deriveAgeLabelFromDateOfBirth = (dateOfBirth, today = new Date()) => {
  const ageYears = calculateAgeYears(dateOfBirth, today);
  if (ageYears == null) return "";
  return String(ageYears);
};
